export default __webpack_public_path__ + "static/media/529.07d12f80.png";